import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { LanguageSwitcher } from '../../../components/LanguageSwitcher';
import type { OnboardingStepId } from '../types';
import { OnboardingMobileProgress } from './OnboardingMobileProgress';
import { OnboardingStepper } from './OnboardingStepper';

export type OnboardingHeaderProps = {
    currentStep: OnboardingStepId;
};

const DESKTOP = 'md';

export function OnboardingHeader({ currentStep }: OnboardingHeaderProps): ReactElement {
    const { t } = useTranslation();

    return (
        <Paper component="header" elevation={1} square sx={{ zIndex: 2, flexShrink: 0 }}>
            <Stack direction="row" sx={{ display: { xs: 'none', [DESKTOP]: 'flex' }, alignItems: 'center' }}>
                <Box sx={{ flex: 1, minWidth: 0, overflowX: 'auto', overflowY: 'hidden' }}>
                    <OnboardingStepper currentStep={currentStep} />
                </Box>
                <Box sx={{ flexShrink: 0, pr: 8 }}>
                    <LanguageSwitcher />
                </Box>
            </Stack>

            <Box sx={{ display: { xs: 'block', [DESKTOP]: 'none' } }}>
                <Stack
                    direction="row"
                    sx={{ height: 35, alignItems: 'center', justifyContent: 'space-between', pl: 3, pr: 1 }}>
                    <Box
                        component="img"
                        src="/houzy_logo.svg"
                        alt={t('HEADER.LOGO_ALT')}
                        sx={{ height: 16, width: 55, objectFit: 'contain' }}
                    />
                    <LanguageSwitcher variant="text" />
                </Stack>
                <Divider />
                <OnboardingMobileProgress currentStep={currentStep} />
            </Box>
        </Paper>
    );
}
